'use client';

import { ModalAnswerTemplatesEditorFromBindings } from '@/components/modal-answer-picked/ModalAnswerTemplatesEditor';
import { ModalAnswerPickedTemplatesBindings } from '@/components/modal-answer-picked/use-modal-answer-picked-templates';
import { UIPriority } from '@/enums/ui-priorities';
import { useClickOutside } from '@/hooks/use-click-outside';
import Button from '@/ui/Button';
import { overlayLayers } from '@/ui/overlay-layers';
import { useRef } from 'react';

type AnswerTemplatesControlProps = ModalAnswerPickedTemplatesBindings & {
    buttonClassName?: string;
};

export const AnswerTemplatesControl = (props: AnswerTemplatesControlProps) => {
    const {
        answerTemplates,
        isTemplatesLoading,
        templatesErrorText,
        isTemplatesMenuOpen,
        isTemplatesEditorShown,
        onToggleTemplatesMenu,
        onCloseTemplatesMenu,
        onOpenTemplatesEditor,
        onApplyTemplate,
        buttonClassName,
    } = props;
    const templateMenuRef = useRef<HTMLDivElement | null>(null);
    useClickOutside(templateMenuRef, () => {
        if (!isTemplatesMenuOpen) {
            return;
        }

        onCloseTemplatesMenu();
    });

    return (
        <>
            <div className="relative" ref={templateMenuRef}>
                <Button
                    priorityType={UIPriority.SECONDARY}
                    uiSize="compact"
                    type="button"
                    onClick={() => void onToggleTemplatesMenu()}
                    className={buttonClassName}
                >
                    Шаблоны
                </Button>
                {isTemplatesMenuOpen && (
                    <div
                        className="absolute bottom-full left-0 mb-1 w-full min-w-[200px] rounded-md border border-slate-200 bg-white p-1 shadow-lg"
                        style={{ zIndex: overlayLayers.overlayModalPopover }}
                    >
                        {isTemplatesLoading ? (
                            <p className="px-2 py-1 text-xs text-slate-500">Загрузка шаблонов...</p>
                        ) : templatesErrorText ? (
                            <p className="px-2 py-1 text-xs text-red-600">{templatesErrorText}</p>
                        ) : (
                            <>
                                {answerTemplates.map((template) => (
                                    <button
                                        key={template.id}
                                        type="button"
                                        className="w-full rounded px-2 py-1.5 text-left text-xs text-slate-700 transition-colors hover:bg-slate-100"
                                        onClick={() => onApplyTemplate(template.id)}
                                    >
                                        {template.name}
                                    </button>
                                ))}
                                <button
                                    type="button"
                                    className="w-full rounded px-2 py-1.5 text-left text-xs text-slate-700 transition-colors hover:bg-slate-100"
                                    onClick={() => void onOpenTemplatesEditor()}
                                >
                                    + Добавить
                                </button>
                            </>
                        )}
                    </div>
                )}
            </div>
            {isTemplatesEditorShown && (
                <ModalAnswerTemplatesEditorFromBindings
                    bindings={props}
                    isShown={isTemplatesEditorShown}
                    setIsShown={(value) => {
                        if (!value) {
                            props.onCloseTemplatesEditor();
                        }
                    }}
                />
            )}
        </>
    );
};
